import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_f441b40e from 'nuxt_plugin_plugin_f441b40e' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_toast_40080b3e from 'nuxt_plugin_toast_40080b3e' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_7c786037 from 'nuxt_plugin_cookieuniversalnuxt_7c786037' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_clipboard_4fdcc26f from 'nuxt_plugin_clipboard_4fdcc26f' // Source: ./clipboard.js (mode: 'client')
import nuxt_plugin_gtm_2084dd25 from 'nuxt_plugin_gtm_2084dd25' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_73d7be8f from 'nuxt_plugin_axios_73d7be8f' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginutils_1c1fbf8c from 'nuxt_plugin_pluginutils_1c1fbf8c' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_492e99d7 from 'nuxt_plugin_pluginrouting_492e99d7' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_539d0e10 from 'nuxt_plugin_pluginmain_539d0e10' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_deviceplugin_5e0b571a from 'nuxt_plugin_deviceplugin_5e0b571a' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_image_5edebb8a from 'nuxt_plugin_image_5edebb8a' // Source: ./image.js (mode: 'all')
import nuxt_plugin_vForm_233a38e6 from 'nuxt_plugin_vForm_233a38e6' // Source: ../plugins/vForm (mode: 'all')
import nuxt_plugin_svgicon_16778036 from 'nuxt_plugin_svgicon_16778036' // Source: ../plugins/svg-icon (mode: 'all')
import nuxt_plugin_tippy_232df670 from 'nuxt_plugin_tippy_232df670' // Source: ../plugins/tippy (mode: 'all')
import nuxt_plugin_helpers_e49953de from 'nuxt_plugin_helpers_e49953de' // Source: ../plugins/helpers (mode: 'all')
import nuxt_plugin_appversion_4b0d07c1 from 'nuxt_plugin_appversion_4b0d07c1' // Source: ../plugins/app-version.client (mode: 'client')
import nuxt_plugin_lightbox_6564ac59 from 'nuxt_plugin_lightbox_6564ac59' // Source: ../plugins/light-box.client (mode: 'client')
import nuxt_plugin_bottomsheet_50f36928 from 'nuxt_plugin_bottomsheet_50f36928' // Source: ../plugins/bottom-sheet.client (mode: 'client')
import nuxt_plugin_directive_10a0b83e from 'nuxt_plugin_directive_10a0b83e' // Source: ../plugins/directive.client (mode: 'client')
import nuxt_plugin_toast_46bc8166 from 'nuxt_plugin_toast_46bc8166' // Source: ../plugins/toast.client (mode: 'client')
import nuxt_plugin_features_466f6631 from 'nuxt_plugin_features_466f6631' // Source: ../plugins/features (mode: 'all')
import nuxt_plugin_auth_963b467e from 'nuxt_plugin_auth_963b467e' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_gtmuserid_3dcf96bf from 'nuxt_plugin_gtmuserid_3dcf96bf' // Source: ../plugins/gtm-user-id.client (mode: 'client')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_hotjar_64f88755 from 'nuxt_plugin_hotjar_64f88755' // Source: ../plugins/hotjar.client (mode: 'client')
import nuxt_plugin_bootIntercom_3e7133a8 from 'nuxt_plugin_bootIntercom_3e7133a8' // Source: ../plugins/bootIntercom.client (mode: 'client')
import nuxt_plugin_sentry_14df2d04 from 'nuxt_plugin_sentry_14df2d04' // Source: ../plugins/sentry.client (mode: 'client')
import nuxt_plugin_editor_f4d3b094 from 'nuxt_plugin_editor_f4d3b094' // Source: ../plugins/editor.client (mode: 'client')
import nuxt_plugin_datetimepicker_94522562 from 'nuxt_plugin_datetimepicker_94522562' // Source: ../plugins/datetime-picker.client (mode: 'client')
import nuxt_plugin_redirectloginen_9c8378b0 from 'nuxt_plugin_redirectloginen_9c8378b0' // Source: ../plugins/redirect-login-en (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"bodyAttrs":{"class":["notranslate"]},"meta":[{"charset":"utf-8"},{"name":"google","content":"notranslate"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"og:site_name","property":"og:site_name","content":"قانونية"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fqanoniah.com\u002Fog_image.png"},{"hid":"og:image:alt","property":"og:image:alt","content":"قانونية"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:locale","property":"og:locale","content":"ar_AA"},{"hid":"twitter:image","name":"twitter:image","content":"https:\u002F\u002Fqanoniah.com\u002Ftwitter_image.png"},{"hid":"twitter:image:alt","name":"twitter:image:alt","content":"قانونية"},{"hid":"twitter:card","name":"twitter:card","content":"summary"},{"hid":"twitter:site","name":"twitter:site","content":"@qanoniah"},{"name":"msapplication-TileColor","content":"#FFFFFF"},{"name":"msapplication-TileImage","content":"\u002Ffavicon-144.png"},{"name":"msapplication-config","content":"\u002Fbrowserconfig.xml"}],"link":[{"rel":"shortcut icon","href":"\u002Ffavicon.ico"},{"rel":"icon","sizes":"16x16 32x32 64x64","href":"\u002Ffavicon.ico"},{"rel":"icon","type":"image\u002Fpng","sizes":"196x196","href":"\u002Ffavicon-192.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"160x160","href":"\u002Ffavicon-160.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"96x96","href":"\u002Ffavicon-96.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"64x64","href":"\u002Ffavicon-64.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16.png"},{"rel":"apple-touch-icon","href":"\u002Ffavicon-57.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"\u002Ffavicon-114.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"\u002Ffavicon-72.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"\u002Ffavicon-144.png"},{"rel":"apple-touch-icon","sizes":"60x60","href":"\u002Ffavicon-60.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"\u002Ffavicon-120.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"\u002Ffavicon-76.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"\u002Ffavicon-152.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Ffavicon-180.png"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"\u002Fcss\u002Ftailwind.css"},{"rel":"preload","href":"\u002Fcss\u002Ftailwind.css","as":"style","onload":"this.rel=\"stylesheet\""}],"script":[{"src":"\u002Fjs\u002Fsnap-pixel.js","async":true},{"src":"\u002Fjs\u002Flinkedin.js","async":true},{"src":"\u002Fjs\u002Fwisepops.js","data-cfasync":false,"async":true},{"src":"\u002Fjs\u002Fintercom-loader.js","defer":true},{"src":"https:\u002F\u002Fuse.fontawesome.com\u002Ff40a6ce48f.js","async":true},{"src":"\u002F\u002Fjs-eu1.hsforms.net\u002Fforms\u002Fv2.js","async":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-N6JWJMD')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-N6JWJMD&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_f441b40e === 'function') {
    await nuxt_plugin_plugin_f441b40e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_40080b3e === 'function') {
    await nuxt_plugin_toast_40080b3e(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_7c786037 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_7c786037(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clipboard_4fdcc26f === 'function') {
    await nuxt_plugin_clipboard_4fdcc26f(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_2084dd25 === 'function') {
    await nuxt_plugin_gtm_2084dd25(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_73d7be8f === 'function') {
    await nuxt_plugin_axios_73d7be8f(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_1c1fbf8c === 'function') {
    await nuxt_plugin_pluginutils_1c1fbf8c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_492e99d7 === 'function') {
    await nuxt_plugin_pluginrouting_492e99d7(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_539d0e10 === 'function') {
    await nuxt_plugin_pluginmain_539d0e10(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_5e0b571a === 'function') {
    await nuxt_plugin_deviceplugin_5e0b571a(app.context, inject)
  }

  if (typeof nuxt_plugin_image_5edebb8a === 'function') {
    await nuxt_plugin_image_5edebb8a(app.context, inject)
  }

  if (typeof nuxt_plugin_vForm_233a38e6 === 'function') {
    await nuxt_plugin_vForm_233a38e6(app.context, inject)
  }

  if (typeof nuxt_plugin_svgicon_16778036 === 'function') {
    await nuxt_plugin_svgicon_16778036(app.context, inject)
  }

  if (typeof nuxt_plugin_tippy_232df670 === 'function') {
    await nuxt_plugin_tippy_232df670(app.context, inject)
  }

  if (typeof nuxt_plugin_helpers_e49953de === 'function') {
    await nuxt_plugin_helpers_e49953de(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_appversion_4b0d07c1 === 'function') {
    await nuxt_plugin_appversion_4b0d07c1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lightbox_6564ac59 === 'function') {
    await nuxt_plugin_lightbox_6564ac59(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bottomsheet_50f36928 === 'function') {
    await nuxt_plugin_bottomsheet_50f36928(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_directive_10a0b83e === 'function') {
    await nuxt_plugin_directive_10a0b83e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_46bc8166 === 'function') {
    await nuxt_plugin_toast_46bc8166(app.context, inject)
  }

  if (typeof nuxt_plugin_features_466f6631 === 'function') {
    await nuxt_plugin_features_466f6631(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_963b467e === 'function') {
    await nuxt_plugin_auth_963b467e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtmuserid_3dcf96bf === 'function') {
    await nuxt_plugin_gtmuserid_3dcf96bf(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hotjar_64f88755 === 'function') {
    await nuxt_plugin_hotjar_64f88755(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bootIntercom_3e7133a8 === 'function') {
    await nuxt_plugin_bootIntercom_3e7133a8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentry_14df2d04 === 'function') {
    await nuxt_plugin_sentry_14df2d04(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_editor_f4d3b094 === 'function') {
    await nuxt_plugin_editor_f4d3b094(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datetimepicker_94522562 === 'function') {
    await nuxt_plugin_datetimepicker_94522562(app.context, inject)
  }

  if (typeof nuxt_plugin_redirectloginen_9c8378b0 === 'function') {
    await nuxt_plugin_redirectloginen_9c8378b0(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
